module.exports = __webpack_public_path__ + "static/media/search02.99393704.png";